// extracted by mini-css-extract-plugin
export default {"card":"DevCard_card__u51sg","colored":"DevCard_colored__EDomG","actions":"DevCard_actions__3hWAD"};